module.exports = __webpack_public_path__ + "static/media/mars-stroke-h.6a194dea.svg";